import { HashLink as Link } from 'react-router-hash-link';
import routes from 'src/routes';
import Page from 'src/components/Page';
import SpecLink from 'src/components/SpecLink';
import ExpandDoc from 'src/components/ExpandDoc';

function AddressVerificationServicePage() {
    return <Page header="Address Verification Service (AVS)">
        <p>
            Address Verification Service (AVS) is a fraud prevention mechanism that validates a customer's billing address against the records held by their card issuer. 
            The response returns an AVS result code indicating the match status.
        </p>
        <p>
            BPOINT does not automatically decline transactions based on AVS outcomes. 
            Your integration is responsible for evaluating the result and determining whether to proceed with payment processing.
        </p>
        <p>
            To enable AVS, please contact your Relationship Manager or our Merchant Support Helpdesk on 1800 230 177 (option 1, 3, 1) Monday to Friday 9am to 5pm (AEST).</p>
        <p>
            To verify the customer's address, perform the following:
        </p>
        <ol>
            <li><SpecLink uriFragment="#operation/TxnAuthkey_CreateAuthkey">Create authkey</SpecLink></li>
            <li><SpecLink uriFragment="#operation/TxnAuthkey_AttachTxnDetails">Attach transaction details</SpecLink> (Set <code>action</code> property to <code>VerifyOnly</code> value)</li>
            <li><SpecLink uriFragment="#operation/TxnAuthkey_AttachCustomerDetails">Attach Customer details</SpecLink> (all fields listed below are mandatory)
                <ExpandDoc
                    method="BPOINT.txns.authkey.AttachCustomerDetails"
                    doc={{
                        personalDetails: {
                            type: 'object',
                            description: <>Personal Details</>,
                            children: {
                                firstName: {
                                    type: "string",
                                    description: "First Name must match cardholder's first name",        
                                },                                        
                                lastName: {
                                    type: "string",
                                    description: "Last Name must match cardholder's last name",
                                }
                            }
                        },
                        contactDetails: {
                            type: 'object',
                            description: <>Contact Details</>,
                            children: {
                                emailAddress: {
                                    type: "string",
                                    description: "Email Address",        
                                }
                            }
                        },
                        address: {
                            type: 'object',
                            description: <>Address Details</>,
                            children: {
                                addressLine1: {
                                    type: "string",
                                    description: "Address Line 1",        
                                },
                                city: {
                                    type: "string",
                                    description: "City",        
                                },
                                state: {
                                    type: "string",
                                    description: "State",        
                                },
                                postcode: {
                                    type: "string",
                                    description: "Postcode",        
                                },
                                countryCode: {
                                    type: "string",
                                    description: "Country Code",        
                                }
                            }
                        }
                    }}
                />
            </li>
            <li><SpecLink uriFragment="#operation/TxnAuthkey_AttachPaymentMethod">Attach payment method</SpecLink> (card details only)</li>
            <li><SpecLink uriFragment="#operation/TxnAuthkey_ProcessExtended">Process transaction Extended</SpecLink>
                    <ExpandDoc
                    method="BPOINT.txns.authkey.ProcessExtended"
                    doc={{
                        txn: {
                            type: 'object',
                            description: <>Transaction response with AVS result set</>,
                            children: {
                                avsResult: {
                                    type: "string",
                                    description: "AVS result set", 
                                    children: {
                                        code: {
                                            type: "string",
                                            description: "AVS result code",
                                        },
                                        rawCode: {
                                            type: "string",
                                            description: "AVS result raw code",
                                        }
                                    }      
                                },                                        
                                
                            }
                        },
                    }}
                />
            </li>
        </ol>
        <p>
            For more information, see <Link to={routes.reference.avsResultCodes}>AVS result codes</Link>.
        </p>
    </Page>
}

export default AddressVerificationServicePage;
